import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import firebase from '../../../firebase'
import "firebase/auth";

import { Spinner, Alert, Container, Card, Button } from "react-bootstrap";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";


const VisualisationReponses = () => {
    const { id } = useParams();
    const [responses, setResponses] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [decryptedCard, setDecryptedCard] = useState(null);
    const [l, setLoad] = useState(false);
    const [booking, setBooking] = useState(null)

    const verifyCode = async (email, code, encryptedData) => {
        try {
            const verify = firebase.functions().httpsCallable("verifyCode");
            await verify({ email, code });
            // console.log(result.data.message);
            // Accès accordé
            toast.success("Accès accordé, vous pouvez maintenant accéder aux données.");
            try {
                const bytes = CryptoJS.AES.decrypt(encryptedData, responses.reservationId);
                const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                setDecryptedCard(decryptedData);
                setLoad(false)
            } catch (err) {
                console.error("Erreur de décryptage : ", err);
                toast.error("Erreur de décryptage");
                // return "Erreur de décryptage";
            } finally {
                setLoad(false)
            }
        } catch (error) {
            console.error("Erreur :", error.message);
            toast.error("Code incorrect ou expiré, déconnexion");
        } finally {
            setLoad(false)
        }
    };


    const sendVerificationCode = async (email, encryptedData) => {
        if (!email) {
            return;
        }
        setLoad(true)
        try {
            const sendCode = firebase.functions().httpsCallable("sendVerificationCode")
            await sendCode({ email });
            // console.log(result.data.message); 
            const userInput = prompt("Veuillez entrer votre code de vérification dans votre boite d'email :");

            if (userInput !== null) {
                await verifyCode(email, userInput, encryptedData);
                setLoad(true)
                // alert(`Vous avez saisi le code : ${userInput}`);
            } else {
                toast.error('code invalide');
            }
        } catch (error) {
            console.error("Erreur :", error);
        } finally {
            setLoad(false)
        }
    };


    const handleDecrypt = (encryptedData) => {
        // let b = firebase.auth().currentUser?.email;
        // console.log('firebase.auth().currentUser', firebase.auth().currentUser)
        // console.log('firebase.auth().currentUser?.email',b , encryptedData)
        sendVerificationCode(firebase.auth().currentUser?.email, encryptedData)
    };


    const getBooking = (id) => {
        firebase.firestore().collection('bookings').doc(id).get().then(doc => {
            if (doc) {
                let d = doc.data()
                d.id = doc.id;
                d.email = d?.emails?.join(', ');
                console.log("reservation", d);
                setBooking(d)
            }
        })
    }

    useEffect(() => {
        const fetchResponses = async () => {
            try {
                const doc = await firebase.firestore().collection("questions").doc(id).get();
                if (doc.exists) {
                    setResponses(doc.data());
                    getBooking(doc.data().reservationId);
                } else {
                    setError("Aucune donnée trouvée pour cet identifiant.");
                }
            } catch (err) {
                setError("Erreur lors du chargement des données.");
            } finally {
                setLoading(false);
            }
        };

        fetchResponses();
    }, [id]);

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Chargement des réponses...</p>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="text-center mt-5">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    if (!responses || !responses.result || responses.result.length === 0) {
        return (
            <Container className="text-center mt-5">
                <Alert variant="warning">Aucune réponse disponible.</Alert>
            </Container>
        );
    }

    const { result } = responses;



    const ReservationDetails = ({ data }) => {
        if (!data) {
            return <p>Aucune donnée disponible</p>;
        }

        const {
            client,
            checkin,
            checkout,
            property,
        } = data;

        const checkinDate = checkin?.toDate().toLocaleDateString("fr-FR");
        const checkoutDate = checkout?.toDate().toLocaleDateString("fr-FR");

        return (
            <div className="reservation-details ">
                <h2>Détails de la réservation</h2>
                <div className="client-info">
                    <p>Nom : {client?.label}</p>
                    <p>Email : {client?.email}</p>
                    <p>Check-in : {checkinDate}</p>
                    <p>Check-out : {checkoutDate}</p>
                    <p>Propriété : {property?.label}</p>
                </div>
            </div>
        );
    };

    return (
        <>
            <h2 className="mb-4">Visualisation des réponses</h2>
            {booking && (<Card className="p-3 mb-4">
                <ReservationDetails data={booking} />
            </Card>)}
            <Card className="p-3">
                <h2>Résponses aux questions</h2>
                <ul className="list-unstyled">
                    {result.map((item, index) => {
                        if (!item.answer || item.answer.length === 0) return null; // Ignorer les réponses vides ou nulles

                        const isCardType = item.question.toLowerCase().includes("carte bleue");

                        return (
                            <li key={index} className="mb-4">
                                <strong>{item.question}</strong>
                                <div className="mt-2">
                                    {isCardType ? (
                                        <div>
                                            {decryptedCard ? (
                                                <ul>
                                                    <li><strong>Numéro de carte :</strong> {decryptedCard.cardNumber}</li>
                                                    <li><strong>Date d'expiration :</strong> {decryptedCard.expiryDate}</li>
                                                    <li><strong>CCV :</strong> {decryptedCard.ccv}</li>
                                                </ul>
                                            ) : (
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    disabled={l}
                                                    onClick={() => handleDecrypt(item.answer)}
                                                >
                                                    {l ? 'Chargement ...' : 'Décrypter la carte'}
                                                </Button>
                                            )}
                                        </div>
                                    ) : Array.isArray(item.answer) ? (
                                        <ul>
                                            {item.answer.map((ans, idx) => (
                                                <li key={idx}>{ans}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span>{item.answer}</span>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </Card>
        </>
    );
};

export default VisualisationReponses;